<template>
    <main class="QuieroEsteCupon-MAIN">

        <section class="section-lo-necesitas" v-if="step == 0">
            <img src="../assets/close-btn.png" class="close-btn" @click="closePopup()"/>
            <img src="../assets/lo-necesitas.png"/>
            <img src="../assets/btn-aceptar.png" @click="step = 1"/>
        </section>

        <section class="section-cupon-descargar" v-if="step == 1" ref="cupon">
            <img src="../assets/close-btn.png" class="close-btn" @click="closePopup()" ref="btnClose"/>

            <img :src="detail.url_banner" class="cupon-descargar-banner" crossorigin="anonymous"/>
            <img :src="detail.url_logo" class="cupon-descargar-logo" crossorigin="anonymous"/>

            <p>{{ detail.descuento }}</p>
            <p v-html="detail.observacion_descuento"></p>

            <p>Código</p>
            <!--<img src="../assets/examples/code.png" class="cupon-descargar-code"/>-->
            <!-- SI ES URL -->
            <div v-if="isValidUrl(detail.cupon)" class="external-warning">
                <button @click="toExternalActive = true">
                    Ir al sitio
                </button>
            </div>
            <!-- SI NO ES URL -->
            <div v-else>
                <h3>{{ detail.cupon }}</h3>
            </div>

            <p>Términos y Condiciones</p>

            <p v-show="detail.instrucciones" v-html="detail.instrucciones">
            </p>

            <img src="../assets/descargar-btn.png" class="cupon-descargar-btn" @click="downloadCupon(), registerDownload()" ref="btnDownload"/>
        </section>

    </main>

    <div class="QuieroEsteCupon-external" v-if="toExternalActive">
        <div class="external-warning">
            <img src="../assets/close-btn.png" class="close-btn" @click="toExternalActive = false"/>
            <p>
                El enlace que seleccionaste te llevará a un sitio externo a BBVA
            </p>
            <button @click="goToExternal(detail.cupon)">
                Continuar
            </button>
        </div>
    </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
    name: 'QuieroEsteCupon',
    props: {
        detail: Object
    },
    data(){
        return{
            step: 1, // 0
            toExternalActive: false,
        }
    },
    methods: {
        closePopup(){
            this.$parent.quieroEsteCuponActive = false;
        },

        downloadCupon() {
            const element = this.$refs.cupon;
            const btnClose = this.$refs.btnClose;
            const btnDownload = this.$refs.btnDownload;

            // Ocultar botones antes de exportar
            if (btnClose) btnClose.style.display = "none";
            if (btnDownload) btnDownload.style.display = "none";
            if (element) element.style.borderRadius = 0;

            const opt = {
                margin: 0.5,
                filename: 'cupon.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 4, useCORS: true },
                jsPDF: { unit: 'in', format: 'a6', orientation: 'portrait' }
            };

            html2pdf()
            .set(opt)
            .from(element)
            .save()
            .then(() => {
                // Mostrar los botones nuevamente
                if (btnClose) btnClose.style.display = "";
                if (btnDownload) btnDownload.style.display = "";
                if (element) element.style.borderRadius = "0 0 1ch 1ch";
            })
            .catch(() => {
                // En caso de error, asegurarse de restaurarlos
                if (btnClose) btnClose.style.display = "";
                if (btnDownload) btnDownload.style.display = "";
                if (element) element.style.borderRadius = "0 0 1ch 1ch";
            });
        },

        async registerDownload(){
            const response = await fetch('https://promo-colaboradores.ideeo.mx/api/descargas', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id,
                    cupon_id: this.detail.id
                })
            });
            const result = await response.json();
            console.log("Registrar descarga", result)
        },

        isValidUrl(value) {
            if (!value) return false;
            try {
                new URL(value);
                return true;
            } catch (_) {
                return false;
            }
        },

        goToExternal(url) {
            window.open(url, '_blank');
            this.toExternalActive = false;
        },

    }
}
</script>

<style scoped>
.QuieroEsteCupon-MAIN{
    width: calc(100% - (1vw - 1vh) * 2);
    height: calc(100vh - (1vw - 1vh) * 2);
    padding: calc(1vw - 1vh);
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #070d3c80;
    position: fixed;
    top: 0;
    left: 0;
    font-family: sans-serif;
    z-index: 2;
    overflow-y: auto;
}

section{
    background-color: #F6F6F6;
    padding: 1ch;
    border-radius: 1ch;
    width: 40ch;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin: auto;
}

.close-btn{
    position: absolute;
    width: 2.5ch;
    top: -1ch;
    right: -1ch;
}

.close-btn:hover{
    cursor: pointer;
    scale: 1.1;
}

.section-lo-necesitas img:not(.close-btn){
    width: 100%;
    margin-top: 1ch;
    margin-bottom: -1ch;
}

.section-lo-necesitas > img:last-child{
    height: 4ch;
    width: auto;
    margin-bottom: 1ch;
    cursor: pointer;
}

/* descargar section */
.section-cupon-descargar{
    border-radius: 0 0 1ch 1ch;
    padding: 0;
}

.cupon-descargar-banner{
    width: 100%;
}

.cupon-descargar-logo{
    width: 10ch;
    aspect-ratio: 1/1;
    object-fit: cover;
    margin-top: -5ch;
    box-shadow: rgba(0, 0, 0, 0.25) 0 0.5ch 0.5ch;
}

h3{
    color: black;
    background-color: white;
    padding: 1ch 1.5ch;
    border-radius: 5px;
    margin: 0;
}

.section-cupon-descargar > p:nth-child(4){
    font-family: 'Benton Sans BBVA bold';
    font-style: italic;
    margin-top: 0.75ch;
    margin-bottom: 0;
    color: black;
    font-size: 2ch;
}

.section-cupon-descargar > p:nth-child(5){
    margin-top: 0;
    margin-bottom: 0;
    color: black;
    font-size: 1.2ch;
    font-style: italic;
    margin-bottom: 0;
    max-width: 95%;
}

.section-cupon-descargar > p:nth-child(6){
    font-family: 'Benton Sans BBVA bold';
    font-size: 2.4ch;
    color: rgba(191, 191, 191, 0.824);
    margin: 0.5ch;
}

.cupon-descargar-code{
    width: 20ch;
}

.section-cupon-descargar > p:nth-child(8){
    font-family: 'Benton Sans BBVA bold';
    color: #051283;
}

.section-cupon-descargar > p:nth-child(9){
    background-color: #D9F1FF;
    color: #051283;
    text-align: center;
    max-width: 85%;
    font-size: 1ch;
    padding: 2ch;
}

.external-warning{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.external-warning >p{
    width: 75%;
    text-align: center;
    color: #051283;
    font-size: 1.5ch;
}

.external-warning >button{
    border: none;
    border-radius: 5px;
    color: white;
    background-color: #051283;
    padding: 5px 10px;
    cursor: pointer;
    margin-bottom: 10px;
}

.cupon-descargar-btn{
    height: 4ch;
    margin-top: 0.5ch;
    margin-bottom: 1.25ch;
}

.QuieroEsteCupon-external{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100vh;
    z-index: 2;
}

.QuieroEsteCupon-external >div{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    border-radius: 10px;
    background-color: white;
}

.cupon-descargar-btn:hover{
    cursor: pointer;
    filter: brightness(1.1);
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .QuieroEsteCupon-MAIN{
        max-height: 100vh;
        justify-content: flex-start;
        overflow: auto;
    }

    .section-lo-necesitas{
        width: 90vw;
        margin: auto;
    }

    .section-lo-necesitas > img:last-child{
        height: unset;
        width: 40vw;
    }

    /* descargar section */
    .section-cupon-descargar{
        max-width: 95vw;
        margin: 1vh 0;
    }

}
</style>